import React from 'react';

export const PauseIcon = ({height = 64, width = 64, fill = "#FFFFFF"}) => {

    return (
        <svg className="w-6 h-6 text-gray-800 dark:text-white" aria-hidden="true" width={width}
             height={height} fill={fill} viewBox="0 0 24 24">
            <path fillRule="evenodd"
                  d="M8 5a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h1a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2H8Zm7 0a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h1a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2h-1Z"
                  clipRule="evenodd"/>
        </svg>
    )
};